import React, { useEffect, useMemo, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ITEM_PER_PAGE, PUBLIC_URL, SEARCH_DELAY } from "../../app.config";
import Pagination from "../../component/Pagination";
import SearchAndExport from "../../component/SearchAndExport";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import useDebounce from "../hooks/useDebounce";
import * as API from "../../utils/api.service";
import { PermissionContext } from "../../context/PermissionContext";
import { FaTrophy } from "react-icons/fa";
import Cookies from "js-cookie";
import {
  ExportToCSV,
  ExportToExcel,
  ExportToPdf,
  handleNoDataFound,
  SWIT_DELETE,
  SWIT_DELETE_SUCCESS,
} from "../../utils/common.service";
import {
  getTournamentApiCall,
  editTournamentApiCall,
} from "../../Store/slices/touenamentSlice";
import { TOAST_ERROR, SWIT_SUCCESS } from "../../utils/common.service";

export default function ManageTournament() {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const debounce = useDebounce(search, SEARCH_DELAY);
  const [page, setPage] = useState(localStorage.getItem("currentPage") || 1);
  const [fieldSort, setFieldSort] = useState("id desc");
  const [ascSort, setAscSort] = useState(false);
  const [sortColumn, setSortColumn] = useState("id");
  const [isActive, setIsActive] = useState("Inactive");
  const location = useLocation();
  const path = location.pathname;
  useEffect(() => {
    localStorage.setItem("modulePath", path);
    localStorage.setItem("currentPage", page);
  }, []);

  const handlePageChange = (newPage) => {
    localStorage.setItem("currentPage", newPage);
    setPage(newPage);
  };

  let userData = Cookies.get("dataCA")
    ? JSON.parse(Cookies.get("dataCA"))
    : null;
  const role = userData ? userData.role : null;
  const { permissions } = useContext(PermissionContext);

  const handleSortChange = (fieldName, sort) => {
    if (sort === "asc") {
      setFieldSort(`${fieldName} ${sort}`);
      setSortColumn(fieldName);
      setAscSort(true);
    } else {
      setFieldSort(`${fieldName} ${sort}`);
      setSortColumn(fieldName);
      setAscSort(false);
    }
  };

  const {
    tournamentList: { data: tournamentList },
  } = useSelector((state) => state.tournament);
  //console.log("tournamentList :", tournamentList);

  useEffect(() => {
    handleCompanyListAPI();
  }, [page, debounce, fieldSort]);

  const handleCompanyListAPI = () => {
    let submitData = {
      search: debounce,
      page: page,
      fieldSort,
    };
    // let request = {};
    dispatch(getTournamentApiCall(submitData));
  };

  const handleStatusChange = async (id, currentStatus) => {
    //console.log("currentStatus :", currentStatus);
    dispatch(setLoader(true));
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

    let submitData = { id, status: newStatus };

    try {
      const { code, message } = await API.deleteTournamentApi(submitData);
      if (code === "1") {
        SWIT_SUCCESS(message);
      }
      dispatch(
        getTournamentApiCall({
          search: debounce,
          page: page,
          fieldSort: fieldSort,
        })
      );

      SWIT_DELETE_SUCCESS(`Status changed to ${newStatus} successfully`);
    } catch (error) {
      console.error("Error changing status:", error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleDeleteManage = async (id) => {
    SWIT_DELETE(`You won't be able to delete this!`).then(async (result) => {
      if (result?.isConfirmed) {
        dispatch(setLoader(true));
        try {
          dispatch(setLoader(true));
          // Prepare the request body, sending only validRanges
          let submitData = {
            id: id,
            status: "Deleted",
          };
          const { code, message } = await API.deleteTournamentApi(submitData);
          if (code === "1") {
            SWIT_SUCCESS(message);
          }

          dispatch(setLoader(false));
        } catch (err) {
          TOAST_ERROR(err.message);
          dispatch(setLoader(false));
        }
        await handleCompanyListAPI();
        await SWIT_DELETE_SUCCESS(`Tournament delete successfully`);
      }
    });
  };

  //   const handleDeleteManage = async (id) => {
  //     SWIT_DELETE(`You won't be able to delete this!`).then(async (result) => {
  //       if (result?.isConfirmed) {
  //         dispatch(setLoader(true));
  //         let submitData = {
  //           id: id,
  //           status:"Inactive",
  //         };

  //         await dispatch(editClientDataApiCall(submitData));
  //         await handleCompanyListAPI();
  //         await SWIT_DELETE_SUCCESS(`Client delete successfully`);
  //       }
  //     });
  //   };

  // const handleExportApiCall = async (type) => {
  //   dispatch(setLoader(true));
  //   let submitData = {
  //     search: debounce,
  //     fieldSort,
  //   };
  //   const { code, data } = await API.getClientExportListApi(submitData);
  //   if (code === "1") {
  //     if (type === "PDF") {
  //       ExportToPdf(data, "clientList", "Client List");
  //     } else if (type === "CSV") {
  //       ExportToCSV(data, "clientList");
  //     } else if (type === "EXCEL") {
  //       ExportToExcel(data, "clientList");
  //     }
  //   }
  //   dispatch(setLoader(false));
  // };

  // console.log("*****************************************",clientList);
  const companyListData = useMemo(() => {
    return tournamentList?.map((item, index) => (
      <>
        <tr key={index}>
          <td>{item?.id}</td>
          <td>{item?.tournament_title}</td>
          <td>
            <img
              src={item?.tournament_image}
              alt="Tournament Image"
              style={{ width: "50px", height: "50px", objectFit: "contain" }}
            />
          </td>
          <td>
            <img
              src={item?.latter_image}
              alt="Latter Image"
              style={{ width: "50px", height: "50px", objectFit: "contain" }}
            />
          </td>
          {/* <td>
            <img
              src={item?.background_image}
              alt="Background Image"
              style={{ width: "50px", height: "50px", objectFit: "cover" }}
            />
          </td> */}
          <td>{item?.created_by}</td>
          <td>{item?.wining_point}</td>
          <td>{item?.start_date}</td>
          <td>{item?.end_date}</td>
          <td>{item?.max_participation}</td>
          {role == "admin" ||
          (permissions[2]?.module_id === 3 &&
            permissions[2]?.permission_update === 1) ? (
            <td>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`is_active_${item.id}`}
                  checked={item?.status === "Active"}
                  onChange={(e) => {
                    // console.log("e--------------------", e.target.value);
                    handleStatusChange(item?.id, item?.status);
                  }}
                />
              </div>
            </td>
          ) : (
            <td>{item?.status}</td>
          )}

          <td>
            <a
              className="text-reset fs-18 cursor_pointer me-1"
              onClick={() =>
                navigate(`/manage_tournament/view_tournament_leaderboard`, {
                  state: { clientData: item },
                })
              }
            >
              <FaTrophy />
            </a>

            <a
              className="text-reset fs-18 cursor_pointer"
              onClick={() =>
                navigate(`/manage_tournament/view_tournament_details`, {
                  state: { clientData: item },
                })
              }
            >
              <i className="ri-eye-line"></i>
            </a>

            {role == "admin" ||
            (permissions[13]?.module_id === 14 &&
              permissions[13]?.permission_update === 1) ? (
              <a
                className="text-reset fs-18 m-1 cursor_pointer"
                onClick={() =>
                  navigate(`/manage_tournament/edit_tournament`, {
                    state: { clientData: item },
                  })
                }
              >
                {" "}
                <i className="ri-edit-line"></i>
              </a>
            ) : null}

            {role == "admin" ||
            (permissions[13]?.module_id === 14 &&
              permissions[13]?.permission_delete === 1) ? (
              <a
                className="text-reset fs-18 cursor_pointer"
                onClick={() => handleDeleteManage(item?.id)}
              >
                {" "}
                <i className="ri-delete-bin-6-line"></i>
              </a>
            ) : null}
          </td>
        </tr>
      </>
    ));
  }, [tournamentList]);

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar title={`Manage Tournament`} header={`Tournament`} />

          {role == "admin" ||
          (permissions[13]?.module_id === 14 &&
            permissions[13]?.permission_add === 1) ? (
            <div className="col-sm-6 mb-2">
              <div className="d-flex justify-content-end">
                <div className="gap-2">
                  <button
                    type="button"
                    className="btn btn-soft-primary"
                    onClick={() =>
                      navigate(`/manage_tournament/add_tournament`)
                    }
                  >
                    <i className="ri-settings-2-line align-text-bottom me-1 fs-16 lh-1"></i>
                    Add Tournament
                  </button>
                </div>
              </div>
            </div>
          ) : null}

          <div className="card rounded-3">
            <div className="card-body">
              <div className="rounded-3 mb-3">
                <SearchAndExport
                  searchFieldName={`tournament`}
                  setSearch={setSearch}
                  isExport={false}
                />
              </div>
              <div className="responsive-table-plugin">
                <div className="table-rep-plugin">
                  <div
                    className="table-responsive"
                    data-pattern="priority-columns"
                  >
                    {Object.keys(tournamentList)?.length > 0 ? (
                      <>
                        <table
                          id="tech-companies-1"
                          className="table table-centered mb-0 table-hover "
                        >
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                className={`cursor_pointer bi ${
                                  sortColumn === "id"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "id",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Id
                              </th>

                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "tournament_title"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "tournament_title",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Tournament Title
                              </th>

                              <th scope="col">Tournament Image</th>
                              <th scope="col">Letter Image</th>
                              <th scope="col">Created By</th>
                              {/* <th>BackGround Image</th> */}
                              <th>Wining Points</th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "start_date"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "start_date",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Start Date
                              </th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "end_date"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "end_date",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                End Date
                              </th>
                              <th>Max Participent</th>
                              <th
                                scope="col"
                                className={`cursor_pointer bi ${
                                  sortColumn === "status"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "status",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Status
                              </th>

                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{companyListData}</tbody>
                        </table>
                      </>
                    ) : (
                      <>{handleNoDataFound("Tournament")}</>
                    )}
                  </div>
                  <Pagination
                    per_page={ITEM_PER_PAGE}
                    pageCount={tournamentList[0]?.tournament_count}
                    onPageChange={handlePageChange}
                    page={page}
                    lableName={`Tournament`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
